//ALL COLORS
export const colors = {
  main: "#de3262",
  light: "#FF4D7E",
  dark: "#A3284A",
  gray: "#7b7b7b",
  field: "#4B465C",
  black: "#1A1A1A",
  text_blue: "#4079E9",
};
